<template>
    <a-modal
        :width="'55%'"
        v-model="updateSmartRule"
        :title="$t('supervise.editSuperviseRule')"
        :maskClosable="maskClosable"
        @ok="handleOk">

        <div style="padding:20px;">
            <a-card v-if="ruleTemplate">
                <a-form-item :label="$t('supervise.timeingName')" :label-col="{ xl:{span: 4},lg: { span: 24  } }" :wrapper-col="{ xl:{span: 20},lg: { span: 24  } }">
                    <a-switch size="small" v-model="rollCallSetting"></a-switch>
                </a-form-item>

                <a-row :gutter="24" v-if="rollCallSetting">
                    <a-col :span="1"></a-col>
                    <a-col :span="22" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;">
                        <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-9px;margin-left:-12px">{{$t('supervise.timeingName')}}</a-divider>
                        <a-row style="margin-top:15px"/>
                        <a-row :gutter="24" v-for="(item,index) in rollCall" :key="index">
                            <a-col :xs="{span:18}" :sm="{span:24}">
                                <a-form-item :validateStatus="item.timeValidateStatus" :help="item.timeErrorMessage" :label="$t('supervise.time') + (index + 1)"  v-bind="formItemLayout">
                                    <a-row>
                                        <a-col span="18">
                                            <a-time-picker @change="onTimeChange" size="small"  style="width:98%" format="HH:mm" v-model="item.time" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                                        </a-col>
                                        <a-col span="6" v-if="index == 0 && rollCall.length < 5">
                                            <a-button size="small"  icon="plus"  @click="addRollCall()"></a-button>
                                        </a-col>
                                        <a-col span="6" v-if="index != 0">
                                            <a-button size="small"  icon="delete" @click="deleteRollCall(index)"></a-button>
                                        </a-col>
                                    </a-row>
                                </a-form-item>
                            </a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="1"></a-col>
                </a-row>

                <a-form-item :label="$t('supervise.timeingHeart')"  :label-col="{ xl:{span: 4},lg: { span: 24  } }" :wrapper-col="{ xl:{span: 20},lg: { span: 24  } }">
                    <a-switch size="small" v-model="heartSetting"></a-switch>
                </a-form-item>

                <a-row :gutter="24" v-if="heartSetting">
                    <a-col :span="1"></a-col>
                    <a-col :span="22" style="border-left:1px solid #e9eaec;border-right:1px solid #e9eaec;border-bottom:1px solid #e9eaec;">
                        <a-divider orientation="left" style="position:absolute;font-size:12px;margin-top:-9px;margin-left:-12px">{{$t('supervise.timeingHeart')}}</a-divider>
                        <a-row style="margin-top:15px"/>
                        <a-row :gutter="24" v-for="(item,index) in heartClock" :key="index">
                            <a-col :xs="{span:18}" :sm="{span:24}">
                                <a-form-item :validateStatus="item.timeValidateStatus" :help="item.timeErrorMessage" :label="$t('supervise.time') + (index + 1)"   v-bind="formItemLayout">
                                    <a-row>
                                        <a-col span="18">
                                            <a-time-picker @change="onTimeChange" size="small"  style="width:98%" format="HH:mm" v-model="item.time" :placeholder="$t('supervise.selecteTimeTip')"></a-time-picker>
                                        </a-col>
                                        <a-col span="6" v-if="index == 0 && heartClock.length < 5">
                                            <a-button size="small" icon="plus"  @click="addHeartClock()"></a-button>
                                        </a-col>
                                        <a-col span="6" v-if="index != 0">
                                            <a-button size="small" icon="delete" @click="deleteHeartClock(index)"></a-button>
                                        </a-col>
                                    </a-row>
                                </a-form-item>
                            </a-col>

                        </a-row>
                    </a-col>
                    <a-col :span="1"></a-col>
                </a-row>

                <a-form-item  :label="$t('supervise.applyChild')" v-bind="formItemLayout">
                    <a-checkbox v-model="applyAll"></a-checkbox>
                </a-form-item>

                <a-alert showIcon :message="$t('supervise.applyChildTip')" type="info"></a-alert>
            </a-card>
        </div>
    </a-modal>
</template>

<script>
    import config from '@/config'
    import moment from 'moment'
    import 'moment/locale/zh-cn';
    import ACol from "ant-design-vue/es/grid/Col";
    moment.locale('zh-cn')

    export default {
        components: {ACol},
        name: 'ZUpdateSmartConfig',
        data() {
            return {
                updateSmartRule: false,
                maskClosable: false,
                ruleTemplate: null,
                groupId: null,
                rollCallSetting:false,
                heartSetting:false,
                rollCall: [],
                heartClock: [],
                applyAll: false,
                formItemLayout: {
                    labelCol: {
                        lg: { span: 24 },
                        xl: { span: 4 },
                    },
                    wrapperCol: {
                        lg: { span: 24 },
                        xl: { span: 20 },
                    }
                }
            }
        },
        methods: {
            handleOk() {
                let updateParam = {}
                let _this = this
                if(this.rollCallSetting){
                    let rollCalls = []
                    let validFlag = true
                    this.rollCall.map(function(item){
                        if(!item.time){
                            validFlag = false
                            item.timeValidateStatus = 'error'
                            item.timeErrorMessage = '请设置时间'
                            setTimeout(function(){
                                item.timeValidateStatus = "success"
                                item.timeErrorMessage = null
                            },5000)
                            return
                        }
                        rollCalls.push(item.time.hour() * 3600 + item.time.minute() * 60)
                    })
                    if(!validFlag){
                        return
                    }
                    updateParam.rollCall = rollCalls
                }
                if(this.heartSetting){
                    let heartClocks = []
                    let validFlag = true
                    this.heartClock.map(function(item){
                        if(!item.time){
                            validFlag = false
                            item.timeValidateStatus = 'error'
                            item.timeErrorMessage = '请设置时间'
                            setTimeout(function(){
                                item.timeValidateStatus = "success"
                                item.timeErrorMessage = null
                            },5000)
                            return
                        }
                        heartClocks.push(item.time.hour() * 3600 + item.time.minute() * 60)
                    })
                    if(!validFlag){
                        return
                    }
                    updateParam.heartRate = heartClocks
                }
                updateParam.id = this.ruleTemplate.id
                updateParam.applyAll = this.applyAll
                console.log(updateParam)
                this.$http.put(config.api.rule_template_regular_url,updateParam).then((response) => {
                    if(response.code == 0){
                        _this.updateSmartRule = false
                        this.$notification.success({
                          message: this.$t('global.commitSuccess')
                        })
                        _this.$emit("updateSuccess",this.groupId)
                    } else {
                      _this.$message.error(response.desc)
                    }
                })
            },
            addRollCall() {
                this.rollCall.push({
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                })
            },
            deleteRollCall(index) {
                this.rollCall.splice(index, 1);
            },
            addHeartClock() {
                this.heartClock.push({
                    "time":null,
                    "timeValidateStatus":"success",
                    "timeErrorMessage":null
                })
            },
            deleteHeartClock(index) {
                this.heartClock.splice(index, 1);
            },
            onTimeChange(selectTime){
                if(selectTime){
                    selectTime = moment(selectTime.startOf('minute').valueOf())
                }
            },
            showModel(template,groupId){
              console.log(template)
                this.ruleTemplate = template
                this.groupId = groupId
                this.updateSmartRule = true

                if(template.rollCall && template.rollCall.length > 0){
                    this.rollCallSetting = true
                    let _this = this
                    _this.rollCall = []
                    template.rollCall.map(function(item){
                        _this.rollCall.push({
                            "time":moment(parseInt(moment().startOf('day').valueOf()) + item * 1000),
                            "timeValidateStatus":"success",
                            "timeErrorMessage":null
                        })
                    })
                }else{
                    this.rollCallSetting = false
                    this.rollCall = [{
                        "time":null,
                        "timeValidateStatus":"success",
                        "timeErrorMessage":null
                    }]
                }

                if(template.heartRate && template.heartRate.length > 0){
                    this.heartSetting = true
                    let _this = this
                    _this.heartClock = []
                    template.heartRate.map(function(item){
                        _this.heartClock.push({
                            "time":moment(parseInt(moment().startOf('day').valueOf()) + item * 1000),
                            "timeValidateStatus":"success",
                            "timeErrorMessage":null
                        })
                    })
                }else{
                    this.heartSetting = false
                    this.heartClock = [{
                        "time":null,
                        "timeValidateStatus":"success",
                        "timeErrorMessage":null
                    }]
                }
            }
        }
    }
</script>